<template>
    <select :id="slctBoxId"
            class="go-vendor"
            @change="callSetSelectedValue"
        >
        <option v-if="placeHolder" value="">{{placeHolder}}</option>
        <option
            v-for="option in options"
            :value="option.key"
            :selected="option.key === preset.key"
            :key="option.key">
                <span v-if="option.vendor" :data-icon="option.vendor"></span>
                {{ option.value }}
        </option>
    </select>
</template>

<script>

export default {
    name: "CSelectBoxSingle",
    data() {
        return {
            value: "",
            refresh: false
       }
    },
    props: {
        preset: {                           // 초기 값 리스트
            type: Object,
            default: ()=>{return {}}
        },
        callSetSelectedValue: {
            type: Function,
            default: ()=>{}
        },
        slctBoxId: String,                   // 셀렉트 박스 ID(SPA 페이지에서 로딩된 DOM 중 유일한 값으로 지정할 것)
        options: {
            type: Array,                    // Option 정보 리스트 (일반 Array, 동적 바인딩 구현 시 각 Key값을 가지고 있는 배열을 포함한 Object로 Bind)
            default: ()=>[]
        },
        placeHolder: String,                // PlaceHolder value
        disabled: {
            type: Boolean,
            default: false
        },                                  // Disabled flag
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initSelectBox();
    },
    watch: {
        value(newVal, oldVal) {
            if (this.isRequired && newVal && oldVal) {
                if (newVal.length === 0 && oldVal.length > 0) {
                    $(`.go-vendor.${this.slctBoxId}.ui.dropdown`).attr("data-invalid", true);
                } else {
                    $(`.go-vendor.${this.slctBoxId}.ui.dropdown`).removeAttr("data-invalid");
                }
            }
        },
        preset(newVal) {
            this.value = newVal;
        }
    },
    methods: {
        initSelectBox: function() {
            let self = this;

            $(`#${this.slctBoxId}`).dropdown({
                onChange: function(value, text, $choice) {
                    self.value = value
                    self.$emit('onSelectChange', {'id': self.slctBoxId, 'value': value});
                }
            });
        },
        updateDropdown() {
            let id_value = $(this.$el).find('input').val();
            id_value = (id_value === "" || id_value == null) ? '' : id_value;
            this.$emit('onSelectChange', {'id': this.slctBoxId, 'value': id_value});
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/OptionSelect/CSelectBoxSingle.vue